import { useContext, useEffect, useState } from 'react';
import STORE from '../../../../store';
import AccountPickerContext from '../../../../contexts/AccountPickerContext';
import fiscalPeriodTypeCheckers from './fiscalPeriodTypeCheckers';

const useFiscalPeriods = () => {
  const { selectedAccountId } = useContext(AccountPickerContext);
  const [fiscalPeriods, setFiscalPeriods] = useState<
    FixedPeriods.FiscalPeriod[]
  >([]);

  useEffect(() => {
    STORE.fixedPeriods
      .getFixedPeriodIntervalsRef({
        fixedPeriodId: 'fiscalPeriods',
        accountId: selectedAccountId,
      })
      .onSnapshot((docs) => {
        const newFiscalPeriods: FixedPeriods.FiscalPeriod[] = [];
        docs.forEach((doc) => {
          const period = doc.data();

          if (fiscalPeriodTypeCheckers.isFiscalPeriod(period)) {
            newFiscalPeriods.push(period);
          }
        });
        setFiscalPeriods(newFiscalPeriods);
      });
  }, [selectedAccountId]);

  return { fiscalPeriods };
};

export default useFiscalPeriods;
